import { combineReducers } from 'redux';

import menu from './menu';
import snackbar from './snackbar';
import { userOrgApi } from 'store/userOrg/userOrgSlice';
import projectFilterSliceReducer from './../additional/projectFilter';
import inputDatasetPathReducer from './../additional/inputDatasetPath';
import { stagingApi } from 'store/staging/stagingSlice';
import { workflowApi } from 'store/workflow/workflowSlice';
import { metadataApi } from 'store/metadata/metadataSlice';
import { workflowLWDsApi } from 'store/workflowLWDs/workflowLWDsSlice';
import { transferApi } from 'store/transfer/transferSlice';
import tableOptionsReducer from './../additional/tableOptions';
import { airflowApi } from 'store/airflow/airflowSlice';

const reducers = combineReducers({
    menu,
    snackbar,
    projectFilter: projectFilterSliceReducer,
    tableOptions: tableOptionsReducer,
    inputDatasetPath: inputDatasetPathReducer,

    [userOrgApi.reducerPath]: userOrgApi.reducer,
    [workflowApi.reducerPath]: workflowApi.reducer,
    [stagingApi.reducerPath]: stagingApi.reducer,
    [metadataApi.reducerPath]: metadataApi.reducer,
    [workflowLWDsApi.reducerPath]: workflowLWDsApi.reducer,
    [transferApi.reducerPath]: transferApi.reducer,
    [airflowApi.reducerPath]: airflowApi.reducer,
});

export default reducers;
